import { render } from "./Status_Type.vue?vue&type=template&id=dd35bb5a"
import script from "./Status_Type.vue?vue&type=script&lang=js"
export * from "./Status_Type.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__